export default {
    toDayAndMonth: (dateString) => {
        const d = new Date(dateString);
        return `${d.getDate()}/${d.getMonth() + 1}`;
    },

    toYearMonthAndDay: (dateString) => {
        const d = new Date(dateString);
        return d.toLocaleDateString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },

    toDateAndTime: (dateString) => {
        const d = new Date(dateString);
        return d.toLocaleDateString('sv-SE', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },

    minutesToHoursAndMinutes: (min) =>
    {
        let hours = Math.floor(min / 60);
        let minutes = min - (hours * 60);

        return { "h": hours, "m": minutes };
    },
    toHourAndDay: (dateString) => {
        const d = new Date(dateString);
        const currentDate = new Date();
        const min = Math.abs(currentDate - d);
        let hours = Math.floor(min / (1000 * 60 * 60));
        if(hours <= 24) {
            return d + ' (' + hours + 'h ago)'
        }
        else {
            return d + ' (' + Math.ceil(min / (1000 * 60 * 60 * 24)) + 'd ago)'
        }
    },
};



// WEBPACK FOOTER //
// ./src/common/date/dateUtil.js